import { mergeDeep } from "../../../../utils/Helper";
import { Mode } from "../../../../utils";
import { validation } from "../Collateral";
import { validationHeader } from "../NewCollateral";
import { CustodyIntStatus } from "../../../Collateral/types";
import { func } from "prop-types";

export const custodyReducer = (state, action) => {
  switch (action.type) {
    case "CHANGE_MODE":
      switch (action.mode) {
        case Mode.EDIT:
          return processEdit(state);
        case Mode.PRECHECK:
          return processPrecheck(state);
        case Mode.CONFIRM:
          return processConfirm(state);
        default:
          return state;
      }
    case "SET_COLLATERAL":
      return processSetCustody(state, action.custody);

    case "SET_INITIALS_READONLY":
      return processSetInitialsReadOnly(state);
    case "ADD_COLLATERAL_WARRANTY":
      return addCollateralWarrantyToCollateral(state, action.collateralWarranty);
    case "SET_COLLATERAL_WARRANTY_ITEM":
      return setCollateralWarranyItem(state, action.collateralWarrantyItem);
    case "DELETE_COLLATERAL_WARRANTY_REQUEST":
    case "DELETE_COLLATERAL_WARRANTY_FAIL":
    return deleteCollateralWarranty(state, action); 
    case "CHANGE_FIELDS":
      return processChangeFields(state, action.fields);
    case "CHANGE_FIELDS_COLLATERAL_WARRANTY":
      return processChangeFieldsCollateralWarrany(state, action.fields);
    case "CHANGE_BUTTON_PROPS":
      return changeButtonProps(state, action);
    default:
      return state;
  }
};

function deleteCollateralWarranty(state, action) {
  const collateral = state.collateral;

  switch (action.type) {
    case "DELETE_COLLATERAL_WARRANTY_REQUEST":
      const { collateralWarranty } = action; 
      const index = collateral.collaterals.findIndex((c) => c.index == collateralWarranty);
      collateral.collaterals[index].CollateralStatus = "Inactive";
      break;
    case "DELETE_COLLATERAL_WARRANTY_FAIL":
      collateral.collaterals.forEach((c) =>
      {
        if (c.CollateralStatus = "Inactive"){
          c.CollateralStatus = "Active";
        }
      })
      break;
    }

  return { ...state, collateral: { ...collateral } };
}

function addCollateralWarrantyToCollateral(state, collateralWarranty) {
  const collateral = state.collateral;

  if (collateralWarranty.CollateralId == null) {
    const index = collateral.collaterals.findIndex((c) => c.AssetId == collateralWarranty.AssetId);
    if (index!=-1){
      if (!collateralWarranty.ToEdit){
          collateral.collaterals.push(collateralWarranty);
      }
      else{
        const indexCollateral = collateral.collaterals.findIndex((c) => c.CollateralId == collateralWarranty.CollateralId);
        collateral.collaterals[indexCollateral] = collateralWarranty;
      }
    }
    else{
      collateral.collaterals.push(collateralWarranty);
    }
  } else {
    //if collateralWarranty.id is not null, it is an existing collateralWarranty
    const index = collateral.collaterals.findIndex((c) => c.CollateralId == collateralWarranty.CollateralId);
    collateral.collaterals[index] = collateralWarranty;

  }
  return mergeDeep(
    { ...state },
    {
      collateral: {
        ...collateral,
      },
    }
  );
}

function processSetCustody(state, collateral) {
  const { mode } = state.ui;
  const readonly = {};

  if (mode == Mode.READONLY) {
    Object.keys(collateral).forEach((f) => {
      readonly[f] = true;
    });
  }

  return mergeDeep(
    { ...state },
    {
      ui: {
        loading: false,
      },
      collateral: {
        ...collateral,
      },
      collateralWarrantyItem: {
        ...collateralwarrantyitem,
      },
      fields: {
        readonly,
      },
      buttons: {
        precheck: { visible: mode != Mode.READONLY },
      },
    }
  );
}

function processChangeFields(state, fields) {
  const errors = Object.keys(fields).reduce((f, name) => {
    //f[name] = undefined;
    return f;
  }, {});
  return mergeDeep(
    { ...state },
    {
      collateral: {
        ...fields,
      },
      fields: {
        errors,
      },
    }
  );
}

function setCollateralWarranyItem(state, collateralWarrantyI) {
  return mergeDeep({ ...state }, { collateralWarrantyItem: { ...collateralWarrantyI } });
}

function processChangeFieldsCollateralWarrany(state, fields) {
  const errors = Object.keys(fields).reduce((f, name) => {
    //f[name] = undefined;
    return f;
  }, {});
  return mergeDeep(
    { ...state },
    {
      collateralWarrantyItem: {
        ...fields,
      },
      fields: {
        errors,
      },
    }
  );
}

function processSetInitialsReadOnly(state) {
  return mergeDeep(
    { ...state },
    {
      fields: {
        readonly: {
          accountName: true,
          assetticker: true,
          volume: state.custody.internalstatus != CustodyIntStatus.ClientRequest,
          date: true,
        },
      },
    }
  );
}

function processEdit(state) {
  return mergeDeep(
    { ...state },
    {
      ui: {
        mode: Mode.EDIT,
      },
      buttons: {
        precheck: {
          visible: true,
          loading: false,
        },
        modify: {
          visible: false,
        },
        confirm: {
          visible: false,
          loading: false,
        },
      },
    }
  );
}

function processPrecheck(state) {
  const errors = validateForm(state);

  if (errors == false) {
    const readonly = {};

    Object.keys(state.collateralWarrantyItem).forEach((f) => {
      readonly[f] = true;
    });

    return mergeDeep(
      { ...state },
      {
        ui: {
          mode: Mode.PRECHECK,
        },
        buttons: {
          precheck: {
            loading: true,
          },
        },
        fields: {
          readonly,
        },
      }
    );
  } else {
    return mergeDeep(
      { ...state },
      {
        fields: {
          errors,
        },
      }
    );
  }
}

function processConfirm(state) {
  return mergeDeep(
    { ...state },
    {
      buttons: {
        precheck: {
          visible: false,
          loading: false,
        },
        modify: {
          visible: true,
        },
        confirm: {
          visible: true,
          loading: false,
        },
      },
    }
  );
}

function changeButtonProps(state, { props }) {
  return mergeDeep({ ...state }, { buttons: { ...props } });
}

export function validateFormHeader(state) {
  const errors = {};
  const { collateral, fields } = state;
  const { hiddens } = fields;
  const validations = validationHeader(collateral);

  Object.entries(validations).forEach((entry) => {
    const [name, value] = entry;
    if (!hiddens[name]) {
      if (value.empty) {
        if (collateral[name] == undefined || collateral[name] === "") {
          errors[name] = "Required field";
        } else if (value.autosuggestId && collateral[value.autosuggestId] == undefined) {
          errors[name] = "Must select a value from list";
        } else if (collateral[name] < 0) {
          errors[name] = "the value must be positive";
        }
      }
    }
  });

  // has Errors only add errors to state
  if (Object.keys(errors).length !== 0) {
    mergeDeep(
      { ...state },
      {
        fields: {
          errors,
        },
      }
    );
    return errors;
  }
  return false;
}

export function validateForm(state) {
  const { collateralWarrantyItem, fields } = state;
  const { hiddens } = fields;
  const errors = {};

  const validations = validation(collateralWarrantyItem);

  Object.entries(validations).forEach((entry) => {
    const [name, value] = entry;

    if (!hiddens[name]) {
      if (value.empty) {
        if (collateralWarrantyItem[name] == undefined || collateralWarrantyItem[name] === "") {
          errors[name] = "Required field";
        } else if (value.autosuggestId && collateralWarrantyItem[value.autosuggestId] == undefined) {
          errors[name] = "Must select a value from list";
        } else if (collateralWarrantyItem[name] < 0) {
          errors[name] = "the value must be positive";
        }
      }
      //check if the date is not in the past
      if (value.date) {
        if (collateralWarrantyItem[name] == undefined || collateralWarrantyItem[name] === "") {
          errors[name] = "Required field";
        } else if (new Date(collateralWarrantyItem[name]) < new Date()) {
          errors[name] = "the date must be in the future";
        }
      }
    }
  });

  // has Errors only add errors to state
  if (Object.keys(errors).length !== 0) {
    return errors;
  }

  return false;
}
